import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import {environment} from '../environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    apiBaseUrl: string = environment.apiBaseUrl;

    title = 'app';
    ngOnInit() {
        // const src = 'fdfd';
        // this.showImage(src);
    }

    showImage(src) {

        const imgUrl = this.apiBaseUrl + '/' + src;
       // console.log(imgUrl);

        swal({
            html:  "<img src='" + imgUrl + "' style='width:100%;'>",
            showConfirmButton: false,
            customClass: 'swal-wide',
        });
    }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/app.component.ts